// extracted by mini-css-extract-plugin
export default {"tupacGrid":"cm-z","tupacHeader":"dm-z","tupacHeader2":"em-z","tupacMenu":"fm-z","tupacMenu2":"gm-z","tupacMain":"hm-z","tupacMain2":"im-z"};